// extracted by mini-css-extract-plugin
export default {"bgWarning":"styles-module--bgWarning--EXkhk","changesSaved":"styles-module--changesSaved--e2umR"};